export type ValueRangePreset = { id: string; min: number | null; max: number | null }

export const VALUE_RANGE_PRESETS: ValueRangePreset[] = [
  { id: '0-50000', min: 0, max: 50000 },
  { id: '50000-100000', min: 50000, max: 100000 },
  { id: '100000-150000', min: 100000, max: 150000 },
  { id: '150000-200000', min: 150000, max: 200000 },
  { id: '200000-250000', min: 200000, max: 250000 },
  { id: '250000-300000', min: 250000, max: 300000 },
  { id: '300000-350000', min: 300000, max: 350000 },
  { id: '350000-400000', min: 350000, max: 400000 },
  { id: '400000-450000', min: 400000, max: 450000 },
  { id: '450000-500000', min: 450000, max: 500000 },
  { id: '500000+', min: 500000, max: null },
]
